import { PageWrapper } from "@/components";
import HistoryLogTable from "@/components/History/HistoryLogTable";
import { routes } from "@/helpers";
import { useIntl } from "react-intl";

const parentEntityId = "UserReplacementHistory";

const UserReplacementHistory = () => {
  const intl = useIntl();
  return (
    <>
      <PageWrapper
        pageTitle={intl.formatMessage({ id: "userReplacement.pageTitle" })}
        backButtonRoute={routes.admin.userReplacement.view}
      >
        <HistoryLogTable parentEntityId={parentEntityId} pageSize={10} />
      </PageWrapper>
    </>
  );
};

export default UserReplacementHistory;
